import { React } from 'Imports';
import { VideoEventResponse } from '$Generated/api';
import { AiOverlayContext } from './AiOverlayContext';
import { useAiOverlayState } from './useAiOverlayState';

interface AiOverlayProviderProps {
    children: React.ReactNode;
    eventId: string;
    videoEvent: VideoEventResponse | undefined;
    onVideoEventRefreshed: () => Promise<void>;
}

const AiOverlayProvider = (props: AiOverlayProviderProps) => {
    const value = useAiOverlayState(props.eventId, props.videoEvent, props.onVideoEventRefreshed);

    return <AiOverlayContext.Provider value={value}>{props.children}</AiOverlayContext.Provider>;
};

export default AiOverlayProvider;
